import React, { useState } from "react";
import useCurrency from "../../../../../hooks/useCurrency";

import {

    Button,
    Divider,
    Form,
    InputNumber,
    Space

} from "antd";

import {

    DollarOutlined

} from "@ant-design/icons";

const OfferReplyBox = ({
                           inquiryId,
                           loading,
                           canReply,
                           onSendOffer,
                           currency
                       }) => {

    // Devise de l'offre : celle transmise par l'appelant, sinon celle du
    // pays d'activité (XOF par défaut).
    const { currency: contextCurrency } = useCurrency();

    const [price, setPrice] = useState(null);

    const [packetQuantity, setPacketQuantity] = useState(null);

    const [availablePackets, setAvailablePackets] = useState(null);

    const handleOffer = () => {
        if (
            price == null ||
            packetQuantity == null ||
            availablePackets == null
        ) {
            return;
        }

        onSendOffer({
            offeredUnitPricePerPacket: price,
            offeredQuantityPerPacket: packetQuantity,
            offeredNumberOfPackets: availablePackets,
            currency: currency || contextCurrency,
            measurementUnit: "KG",
            commercialTerms: null,
            expectedDeliveryDate: null,
            deliveryLocation: null
        });

        setPrice(null);
        setPacketQuantity(null);
        setAvailablePackets(null);
    };

    return (

        <div
            style={{
                padding:20,
                background:"#fff"
            }}
        >

            <Divider>

                Offre commerciale

            </Divider>

            <Form layout="vertical">

                <Form.Item label="Prix unitaire">

                    <InputNumber

                        value={price}

                        onChange={setPrice}

                        prefix={<DollarOutlined />}

                        style={{ width:"100%" }}

                        // disabled={!canReply || loading}

                    />

                </Form.Item>

                <Form.Item label="Kg par paquet">

                    <InputNumber

                        value={packetQuantity}

                        onChange={setPacketQuantity}

                        style={{ width:"100%" }}

                        // disabled={!canReply || loading}

                    />

                </Form.Item>

                <Form.Item label="Nombre de paquets">

                    <InputNumber

                        value={availablePackets}

                        onChange={setAvailablePackets}

                        style={{ width:"100%" }}

                        // disabled={!canReply || loading}

                    />

                </Form.Item>

                <Space

                    direction="vertical"

                    style={{ width:"100%" }}

                >

                    <Button

                        type="primary"

                        block

                        // disabled={
                        //
                        //     !canReply ||
                        //
                        //     loading ||
                        //
                        //     price == null ||
                        //
                        //     packetQuantity == null ||
                        //
                        //     availablePackets == null
                        //
                        // }

                        onClick={handleOffer}

                    >

                        Envoyer une offre

                    </Button>

                </Space>

            </Form>

        </div>

    );

};

export default OfferReplyBox;